/**
 * Issuer Hub Layout Route
 *
 * J.2: Route-level wrapper that renders child routes inside the IssuerHubLayout
 * shell. This mirrors the DashboardLayoutRoute pattern but uses the issuer-specific
 * sidebar layout.
 *
 * Access control is handled by <IssuerHubGuard /> wrapping each child route.
 * This component only manages the layout shell and Suspense boundary.
 */

import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import IssuerHubLayout from "@/pages/issuer-hub/IssuerHubLayout";
import { FlexLayout, Spinner } from "@/design-system/salt";

const ContentLoader = () => (
  <FlexLayout align="center" justify="center" style={{paddingTop: "96px", paddingBottom: "96px"}}>
    <Spinner aria-label="Loading issuer page" size="medium" />
  </FlexLayout>
);

/** Issuer Hub Layout Route component. */
export default function IssuerHubLayoutRoute() {
  return (
    <IssuerHubLayout>
      <Suspense fallback={<ContentLoader />}>
        <Outlet />
      </Suspense>
    </IssuerHubLayout>
  );
}
